"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CSSTransition", {
  enumerable: true,
  get: function get() {
    return _CSSTransition.default;
  }
});
Object.defineProperty(exports, "ReplaceTransition", {
  enumerable: true,
  get: function get() {
    return _ReplaceTransition.default;
  }
});
Object.defineProperty(exports, "RouterViewTransition", {
  enumerable: true,
  get: function get() {
    return _RouterView.default;
  }
});
Object.defineProperty(exports, "SwitchTransition", {
  enumerable: true,
  get: function get() {
    return _SwitchTransition.default;
  }
});
Object.defineProperty(exports, "Transition", {
  enumerable: true,
  get: function get() {
    return _Transition.default;
  }
});
Object.defineProperty(exports, "TransitionGroup", {
  enumerable: true,
  get: function get() {
    return _TransitionGroup.default;
  }
});
Object.defineProperty(exports, "TransitionGroupContext", {
  enumerable: true,
  get: function get() {
    return _TransitionGroupContext.default;
  }
});
exports.default = void 0;
var _Transition = _interopRequireDefault(require("react-transition-group/Transition"));
var _TransitionGroup = _interopRequireDefault(require("react-transition-group/TransitionGroup"));
var _ReplaceTransition = _interopRequireDefault(require("react-transition-group/ReplaceTransition"));
var _TransitionGroupContext = _interopRequireDefault(require("react-transition-group/TransitionGroupContext"));
var _SwitchTransition = _interopRequireDefault(require("./SwitchTransition"));
var _CSSTransition = _interopRequireDefault(require("./CSSTransition"));
var _RouterView = _interopRequireDefault(require("./RouterView"));
// @ts-nocheck -- upstream react-transition-group subpath declarations are not available in this package.
var _default = exports.default = _RouterView.default;